var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page push-config" },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "100px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "50px",
                          label: _vm.$t("SystemMaintenance.Branch")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.getCustomerNotificationConfig },
                            model: {
                              value: _vm.branchId,
                              callback: function($$v) {
                                _vm.branchId = $$v
                              },
                              expression: "branchId"
                            }
                          },
                          _vm._l(_vm.currentOfficeList, function(office) {
                            return _c("el-option", {
                              key: office.uuid,
                              attrs: {
                                value: office.officeId,
                                label: office.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.branchId !== 1,
                            expression: "branchId!==1"
                          }
                        ],
                        attrs: {
                          label: _vm.$t(
                            "SystemMaintenance.ApplyTheHeadOfficesSettings"
                          )
                        }
                      },
                      [
                        _c("el-checkbox", {
                          on: { change: _vm.applyHeadOfficeConfig },
                          model: {
                            value: _vm.customerNotifConfigForm.userHeadQuarters,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.customerNotifConfigForm,
                                "userHeadQuarters",
                                $$v
                              )
                            },
                            expression:
                              "customerNotifConfigForm.userHeadQuarters"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "triggers" },
          [
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "30px" },
                attrs: { type: "primary" },
                on: { click: _vm.saveConfig }
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.customerNotifConfigForm.userHeadQuarters,
                "label-width": "600px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                { staticStyle: { width: "500px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("SystemMaintenance.NotificationObject"))
                    )
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.customerNotifConfigForm.sales,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.customerNotifConfigForm,
                                "sales",
                                $$v
                              )
                            },
                            expression: "customerNotifConfigForm.sales"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sales")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.customerNotifConfigForm.salesExcutive,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.customerNotifConfigForm,
                                "salesExcutive",
                                $$v
                              )
                            },
                            expression: "customerNotifConfigForm.salesExcutive"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Supervisor")))]
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } })
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "500px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("SystemMaintenance.NotificationMethod"))
                    )
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.customerNotifConfigForm.internaleReminder,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.customerNotifConfigForm,
                                "internaleReminder",
                                $$v
                              )
                            },
                            expression:
                              "customerNotifConfigForm.internaleReminder"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.InternalReminder"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.customerNotifConfigForm.email,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.customerNotifConfigForm,
                                "email",
                                $$v
                              )
                            },
                            expression: "customerNotifConfigForm.email"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Email")))]
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } })
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "500px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "SystemMaintenance.HowDaysBeforeExpirationNotice"
                        )
                      )
                    )
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays1Flag,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays1Flag",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays1Flag"
                        }
                      }),
                      _c("el-input", {
                        staticStyle: {
                          "padding-right": "3px",
                          "padding-left": "3px",
                          width: "50px"
                        },
                        attrs: {
                          maxlength: "2",
                          onkeyup: "value=value.replace(/[^\\d]/g,'')",
                          onblur:
                            "if(value === '0' || value === '00'){value = ''}"
                        },
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays1,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays1",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays1"
                        }
                      }),
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Days")))
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays2Flag,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays2Flag",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays2Flag"
                        }
                      }),
                      _c("el-input", {
                        staticStyle: {
                          "padding-right": "3px",
                          "padding-left": "3px",
                          width: "50px"
                        },
                        attrs: {
                          maxlength: "2",
                          onkeyup: "value=value.replace(/[^\\d]/g,'')",
                          onblur:
                            "if(value === '0' || value === '00'){value = ''}"
                        },
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays2,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays2",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays2"
                        }
                      }),
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Days")))
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays3Flag,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays3Flag",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays3Flag"
                        }
                      }),
                      _c("el-input", {
                        staticStyle: {
                          "padding-right": "3px",
                          "padding-left": "3px",
                          width: "50px"
                        },
                        attrs: {
                          maxlength: "2",
                          onkeyup: "value=value.replace(/[^\\d]/g,'')",
                          onblur:
                            "if(value === '0' || value === '00'){value = ''}"
                        },
                        model: {
                          value: _vm.customerNotifConfigForm.dueDays3,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customerNotifConfigForm,
                              "dueDays3",
                              $$v
                            )
                          },
                          expression: "customerNotifConfigForm.dueDays3"
                        }
                      }),
                      _vm._v(_vm._s(_vm.$t("SystemMaintenance.Days")))
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "500px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.DayMaintenance")))
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.SleepingDays"),
                            "label-width": "60px"
                          }
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "60px" },
                              attrs: {
                                maxlength: "4",
                                oninput: "value=value.replace(/[^\\d]/g,'')"
                              },
                              model: {
                                value: _vm.customerNotifConfigForm.sleepingDays,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.customerNotifConfigForm,
                                    "sleepingDays",
                                    $$v
                                  )
                                },
                                expression:
                                  "customerNotifConfigForm.sleepingDays"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Days")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.SigningDays"),
                            "label-width": "60px"
                          }
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "60px" },
                              attrs: {
                                maxlength: "4",
                                oninput: "value=value.replace(/[^\\d]/g,'')"
                              },
                              model: {
                                value: _vm.customerNotifConfigForm.signingDays,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.customerNotifConfigForm,
                                    "signingDays",
                                    $$v
                                  )
                                },
                                expression:
                                  "customerNotifConfigForm.signingDays"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Days")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }